webpackJsonp([237188580290166],{

/***/ 1167:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0015_spreading_plague.jpg","type":"Spell","subtype":null,"cost":4,"ATK":null,"HP":null,"rules_text_1":"Destroy all tech 0, I, or II units and heroes that have -1/-1 runes.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Spreading Plague","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Black","spec":"Disease","bottom":"Magic","rulings":[],"keywords":[],"slug":"spreading_plague"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"spreading_plague","keywords":[],"imageRegex":"/spreading_plague.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-spreading-plague-37ca6565d9cb011b53bc.js